// useSearchContractsParams, параметры поиска договора по имени, фамилии и номеру договора
import { useState } from 'react';

// Zustand store
import { useShallow } from 'zustand/react/shallow';
import { useContractsStore } from 'storeZustand';

const useSearchContractsParams = () => {
	const [selectedSearchParams, setSelectedSearchParams] = useState('last_name');

	// Договоры клиента
	const [
		getContractsParams,
	] = useContractsStore(useShallow((state) => [
		state.getContractsParams,
	]));

	const handleSearchParams = (event) => {
		setSelectedSearchParams(event.target.value);
	};

	// Поиск в таблице
	const onSearch = async (value) => {
		if (!value) return;

		const filters = {};

		if (selectedSearchParams === 'last_name') filters.last_name = value;
		if (selectedSearchParams === 'first_name') filters.first_name = value;
		if (selectedSearchParams === 'contract_number') filters.contract_number = value;

		await getContractsParams(filters);
	};

	return { onSearch, handleSearchParams };
};

export default useSearchContractsParams;